<kendo-dropdownlist
[data]="data"
textField="text"
valueField="value"
[(value)]="selectedValue"
(valueChange)="onChange($event)"
>
</kendo-dropdownlist>